import dayjs from "dayjs";
import {
  IResult,
  IdEnum,
  ExperiencesSelectionEnum,
} from "redmond";
import { TripDestination } from "../types";

// Helper to create dates relative to today
const today = dayjs();
const formatDate = (date: dayjs.Dayjs) => date.format("YYYY-MM-DD");

// Mock location object with proper IResult structure
const createMockLocation = (id: string, name: string): IResult => ({
  id: {
    Id: IdEnum.Experiences,
    experiencesSelection: {
      ExperiencesSelection: ExperiencesSelectionEnum.ExperiencesDestination,
      id,
      name,
      searchTerm: name,
    },
  },
  label: name,
});

/**
 * Scenario: No upcoming trips
 * Tests that the section is hidden or shows empty state
 */
export const noTripsMock: TripDestination[] = [];

/**
 * Scenario: Mix of flight and hotel trips
 * Tests that different icons are shown for flights vs hotels
 */
export const flightAndHotelMixMock: TripDestination[] = [
  {
    location: createMockLocation("paris-france", "Paris, France"),
    tripDate: formatDate(today.add(5, "day")),
    tripEndDate: formatDate(today.add(10, "day")),
    source: "Flight",
    coordinates: { lat: 48.8566, lon: 2.3522 },
    displayName: "Paris, France",
  },
  {
    location: createMockLocation("london-uk", "London, UK"),
    tripDate: formatDate(today.add(15, "day")),
    tripEndDate: formatDate(today.add(18, "day")),
    source: "Hotel",
    coordinates: { lat: 51.5074, lon: -0.1278 },
    displayName: "London, UK",
  },
  {
    location: createMockLocation("tokyo-japan", "Tokyo, Japan"),
    tripDate: formatDate(today.add(30, "day")),
    tripEndDate: formatDate(today.add(37, "day")),
    source: "Flight",
    coordinates: { lat: 35.6762, lon: 139.6503 },
    displayName: "Tokyo, Japan",
  },
];

/**
 * Scenario: First trip is ongoing (started yesterday, ends in 3 days)
 * Tests that "ongoing" label is shown instead of "X days away"
 */
export const ongoingTripMock: TripDestination[] = [
  {
    location: createMockLocation("barcelona-spain", "Barcelona, Spain"),
    tripDate: formatDate(today.subtract(1, "day")),
    tripEndDate: formatDate(today.add(3, "day")),
    source: "Hotel",
    coordinates: { lat: 41.3851, lon: 2.1734 },
    displayName: "Barcelona, Spain",
  },
  {
    location: createMockLocation("rome-italy", "Rome, Italy"),
    tripDate: formatDate(today.add(14, "day")),
    tripEndDate: formatDate(today.add(18, "day")),
    source: "Flight",
    coordinates: { lat: 41.9028, lon: 12.4964 },
    displayName: "Rome, Italy",
  },
];

export type MockTripScenario = "none" | "mix" | "ongoing";

export const getMockTripDestinations = (
  scenario: MockTripScenario
): TripDestination[] | null => {
  switch (scenario) {
    case "none":
      return noTripsMock;
    case "mix":
      return flightAndHotelMixMock;
    case "ongoing":
      return ongoingTripMock;
    default:
      return null;
  }
};
